export const SignupSelectorProgram = {
  bindings: {
    isDisabled: '<',
    hasDropdown: '<',
    product: '<',
    products: '<',
    onChange: '&',
  },

  template: `
    <div class="signup-selector-program px-3 px-md-5">
      <div class="dropdown mb-4"
        ng-class="{
          'signup-product--static': !$ctrl.hasDropdown,
          'disabled': $ctrl.isDisabled
        }">
        <a class="signup-tile dropdown-toggler d-block border rounded w-100"
          data-toggle="dropdown">
          <signup-tile-program
            product="$ctrl.product"
            ng-show="$ctrl.product">
          </signup-tile-program>
          <div ng-hide="$ctrl.product" class="px-0 py-1 p-sm-3">
            <span class="h2 text-black font-weight-regular">
              Choose a program
            </span>
          </div>
          <i class="fa fa-chevron-down"></i>
        </a>
        <div class="dropdown-menu border rounded w-100"
          ng-show="$ctrl.hasDropdown && !$ctrl.isDisabled">
          <div class="dropdown-item signup-tile"
            ng-repeat="product in $ctrl.products track by $index"
            ng-class="{ active: $ctrl.product.id === product.id }"
            ng-click="$ctrl.onChange({ voomeProductId: product.id })">
            <signup-tile-program product="product"></signup-tile-program>
          </div>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupSelectorProgram.js